import React, { useState } from 'react';

import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';

import styles from "./installApp.module.css";
import InstallAppContent from './InstallAppContent';
import { InstallPromptProps } from './InstallPrompt.types';

const InstallPrompt = ({ onInstallClick, setInstallBannerToSessionStorage }: InstallPromptProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(true);

    const handleInstallClick = () => {
        setInstallBannerToSessionStorage(true)
        onInstallClick();
        setIsOpen(false);
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            id='installPromptsSnackbar'
            open={isOpen}
        >
            <SnackbarContent
                classes={{
                    root: styles.snackbar_content,
                    message: styles.message,
                }}
                id='installPromptsSnackbarContent'
                message={<InstallAppContent handleInstallClick={handleInstallClick} setInstallBannerToSessionStorage={setInstallBannerToSessionStorage} setIsOpen={setIsOpen} />}
            /></Snackbar>
    );
};

export default InstallPrompt;
